import { BaseCommandProvider } from "common/app/command-palette/providers/base-provider";
import { Command, GetCommandsProps } from "common/app/command-palette/types";

export class OtherProvider extends BaseCommandProvider {
  getCommands({ context, onLogout }: GetCommandsProps): Command[] {
    const commands: Command[] = [];

    if (onLogout) {
      commands.push({
        id: "other:logout",
        label: _("Log out"),
        onClick: () => onLogout(),
        icon: "fa-sign-out",
      });
    }

    commands.push({
      id: "other:profile-settings",
      label: _("Profile Settings"),
      link: `#/${context.site.name}/profile`,
      icon: "fa-cog",
    });

    return commands;
  }
}
